import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Footer from "../Components/Footer";
import Sidebar from "../Components/Sidebar";

function Addaddress() {
  return (
    <>
      <Header />
      <PageHeader pagename="Add New Address" />

      {/* Addaddress section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv edit-address-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">Add New Address</h3>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                    <div className="edit-profile-dv">
                      <button className="btn-all" style={{ width: "32%" }}>
                        save
                      </button>
                    </div>
                  </div> */}
                  <div className="col-md-12">
                    <div className="info-border"></div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      {/* <label className="primary-color">First Name :</label>  */}
                      <h5 className="primary-color">Email Address</h5>
                      <input type="email" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Contact Number</h5>
                      <input type="text" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Address Line</h5>
                      <input type="number" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Country</h5>
                      <input type="text" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">City</h5>
                      <input type="text" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">State</h5>
                      <input type="text" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Postal Code</h5>
                      <input type="text" placeholder="Type here" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="save-btn">
                      <button className="btn-all" style={{ width: "25%" }}>
                        save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}

      <Footer />
    </>
  );
}

export default Addaddress;
